<div [formGroup]="userForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="email"
    placeholder="mail@nexato.de"
    label="Email">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="initials"
    placeholder="RM"
    label="Kürzel">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="firstName"
    placeholder="Ralf"
    label="Vorname">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="lastName"
    placeholder="Müller"
    label="Nachname">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="externalId"
    placeholder="478465214"
    label="Externe ID">
  </nx-edit-text-input>
  <nx-edit-multiselect-input
    formControlName="groupIds"
    [label]="'Gruppen'"
    [options]="groups">
  </nx-edit-multiselect-input>
  <nx-edit-multiselect-input
    formControlName="locationIds"
    [label]="'Niederlassungen'"
    [options]="locations">
  </nx-edit-multiselect-input>
  <nx-edit-text-input
    *ngIf="!user"
    [maskContent]="true"
    formControlName="password"
    helpText="Der Nutzer muss das Passwort bei der nächsten Anmeldung ändern." 
    label="Passwort">
  </nx-edit-text-input>
<div>